import ToggleField from 'components/ToggleField';
import React from 'react';
import { Field } from 'react-final-form';
import enums from 'utilities/enums';
import setClassSuffix from 'utilities/services/ClassManager';
import { NOTIFICATION_SETTINGS_TITLE_BASED_ON_TYPE } from './utils';
const { NOTIFICATION_TYPES } = enums;

const NotificationSettingsTableRow = ({
  rowInfo: { notificationType, askToApprove },
  className,
  namePreffix,
  index,
}) => {
  const setColumnSuffix = setClassSuffix(`${className}__column`);

  return (
    <tr className={`${className}__row`}>
      <td className={setColumnSuffix('__settingLabel')}>
        <p>{NOTIFICATION_SETTINGS_TITLE_BASED_ON_TYPE[notificationType]}</p>
        {askToApprove !== null && (
          <Field
            name={`${namePreffix}[${index}].askToApprove`}
            component={ToggleField}
            label={`Ask to Approve or Reject Deletion of ${
              notificationType === NOTIFICATION_TYPES.ENTITY_DELETED ? 'Entity' : 'Case'
            }`}
          />
        )}
      </td>
      <td className={setColumnSuffix('__notifyViaDashboard')}>
        <span>
          <Field name={`${namePreffix}[${index}].dashboardNotification`} component={ToggleField} />
        </span>
      </td>
      <td className={setColumnSuffix('__notifyViaEmail')}>
        <span>
          <Field name={`${namePreffix}[${index}].emailNotification`} component={ToggleField} />
        </span>
      </td>
    </tr>
  );
};

export default NotificationSettingsTableRow;
